import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    marginBottom: '24px',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '4px',
  },

  title: {
    color: theme.colors.primary,
  },

  tableItemsWrapper: {
    border: `1px solid ${theme.colors.iron}`,
    borderRadius: '4px',

    '& > div:last-child': {
      borderBottom: 'none',
    },
  },

  tableItem: {
    padding: '16px',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    gridColumnGap: '16px',
    alignItems: 'center',
    background: theme.colors.alabaster,
    borderBottom: `1px solid ${theme.colors.iron}`,
  },

  text: {
    '& > p': {
      fontSize: '14px',
    },
  },

  label: {
    fontWeight: 'bold',
  },

  value: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  btnWrapper: {
    display: 'flex',

    '& > div:first-child': {
      marginRight: '16px',
    },
  },

  outlinedRightInput: {
    padding: '8px 0 8px 14px',
  },

  outlinedLeftInput: {
    padding: '8px 14px 8px 0',
  },

  textAlignEnd: {
    textAlign: 'end',
  },
}

export default styles
